import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../utils/localStorage";
import {
  formatDateNew,
  localeDateEndDate,
  maskMobileNumber,
} from "../constants/DateUtil/DateUtil";
import SchedularModal from "./SchedularModal";
import AdminMenu from "./AdminMenu";
import { ProgressSpinner } from "primereact/progressspinner";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { getStoreCustomerLastOrder } from "../services/CustomerInfo/CustomerInfo";
import { getBrandStore } from "../services/StoreUsers/PostStoreUsers";

const { innerHeight: height } = window;

const InactiveCustomer = () => {
  const navigate = useNavigate();

  const { brandProfileData } = getUserData();
  const brandId = brandProfileData?.id;

  const [schedularDate, setSchedularDate] = useState({});
  const [customerALLOrdersData, setCustomerALLOrdersData] = useState([]);
  const [schedularModalVisible, setSchedularModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [brandStoreData, setBrandStoreData] = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState("");
  const [daysBack, setDaysBack] = useState(7);

  useEffect(() => {
    if (!brandId) return;

    getBrandStore(brandId)
      .then((response) => {
        if (!response.data.error) {
          const stores = response.data || [];
          setBrandStoreData(stores);
          if (stores.length === 1) {
            setSelectedStoreId(stores[0].id);
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching stores:", err);
      });
  }, [brandId]);

  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setSchedularDate(newSchedular);
  };

  const fetchStoreOrders = useCallback(
    (data) => {
      setLoading(true);
      getStoreCustomerLastOrder(data)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            setCustomerALLOrdersData(Res);
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        })
        .finally(() => setLoading(false));
    },
    [setCustomerALLOrdersData],
  );

  useEffect(() => {
    if (!brandId || !selectedStoreId) return;

    const safeDaysBack = Number(daysBack) > 0 ? Number(daysBack) : 0;
    const endDateValue = new Date();
    endDateValue.setDate(endDateValue.getDate() - safeDaysBack);

    const data = {
      storeIds: [selectedStoreId],
      brandId: brandId,
      endDate: schedularDate?.endDate
        ? localeDateEndDate(new Date(schedularDate.endDate))
        : localeDateEndDate(endDateValue),
    };

    fetchStoreOrders(data);
  }, [schedularDate, fetchStoreOrders, selectedStoreId, daysBack, brandId]);

  const exportExcel = async () => {
    const xlsx = await import("xlsx");
    const exportData = customerALLOrdersData.map((order, index) => ({
      "S No.": index + 1,
      "Last Bill No.": order.invoiceNo,
      "Booking Date": formatDateNew(order.createdDate),
      "Customer Name": order.customerName?.replace(/_/g, " "),
      Mobile: maskMobileNumber(order.customerMobile?.replace(/_/g, " ")),
      Address: order.customerAddress?.replace(/_/g, " "),
      "Order Source": order.orderSource?.replace(/_/g, " "),
      "Delivery Remarks": order.deliveryRemarks,
    }));

    const worksheet = xlsx.utils.json_to_sheet(exportData);
    const workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, "Last Orders");

    const storeName = brandStoreData
      .find((store) => store.id === selectedStoreId)
      ?.storeName?.replace(/[^a-z0-9_-]/gi, "_");
    xlsx.writeFile(
      workbook,
      `Customer_Last_Orders${storeName ? `_${storeName}` : ""}.xlsx`,
    );
  };

  const invoiceBodyTemplate = (rowData) => {
    return (
      <div
        className="cursor-pointer"
         
      >
        <span  >
          {rowData?.invoiceNo}
        </span>
      </div>
    );
  };

  const customerName = (rowData) => {
    return (
      <div>
        <p>
          {rowData?.customerName?.replace(/_/g, " ").substring(0, 16)}
          {rowData?.customerName?.length > 16 ? "..." : ""}
        </p>
      </div>
    );
  };

  const RenderTabView = () => {
    return (
      <DataTable
        showGridlines
        value={customerALLOrdersData}
        // header={header}
        paginator
        rows={50}
        rowsPerPageOptions={[50, 75, 100]}
        // tableStyle={{ minWidth: "100rem" }}
        stripedRows
      >
        <Column
          header="S No."
          //   style={{ width: "40px" }}
          body={(rowData, options) => options.rowIndex + 1}
        ></Column>
        <Column
          field="invoiceNo"
          header="Last Bill No."
          style={{
            // width: "85px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={invoiceBodyTemplate}
        ></Column>
        <Column
          field="createdDate"
          header="Booking Date"
          style={{
            // width: "110px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => formatDateNew(rowData?.createdDate)}
        />

        <Column
          field="customerName"
          header="Customer Name"
          style={{
            // width: "140px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={customerName}
        ></Column>
        <Column
          field="customerMobile"
          header="Mobile"
          style={{
            // width: "100px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) =>
            maskMobileNumber(rowData?.customerMobile?.replace(/_/g, " "))
          }
        ></Column>

        <Column
          field="customerAddress"
          header="Address"
          style={{
            // width: "100px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => rowData?.customerAddress?.replace(/_/g, " ")}
        ></Column>

        <Column
          field="orderSource"
          header="Order Source"
          style={{
            // width: "100px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
          body={(rowData) => rowData?.orderSource?.replace(/_/g, " ")}
        ></Column>

        <Column
          field="deliveryRemarks"
          header="Delivery Remarks"
          style={{
            // width: "200px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }}
        ></Column>
      </DataTable>
    );
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Customers")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Inactive Customer
              </p>
            </div>
          </div>

          {(selectedStoreId || customerALLOrdersData.length > 0) && <div className="flex justify-content-center align-items-center">
            <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
              <img
                onClick={exportExcel}
                src={"images/file.png"}
                style={{
                  width: 30,
                }}
              />
            </div>
          </div>}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="mx-4 my-4">
        <div className="flex flex-wrap align-items-center gap-3 mb-3">
          <div style={{ flex: "1 1 0", minWidth: 220 }}>
            <label className="block text-md font-bold mb-2 text-900">
              Store
            </label>
            <Dropdown
              value={selectedStoreId}
              options={brandStoreData.map((store) => ({
                label: store.storeName,
                value: store.id,
              }))}
              onChange={(e) => setSelectedStoreId(e.value)}
              placeholder="Select store"
              className="w-full"
              showClear={false}
            />
          </div>

          <div style={{ flex: "1 1 0", minWidth: 180 }}>
            <label className="block text-md font-bold mb-2 text-900">
             Inactive for in days
            </label>
            <InputText
              value={daysBack}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                setDaysBack(value === "" ? 0 : Number(value));
              }}
              keyfilter="int"
              placeholder="e.g. 10"
              className="w-full"
            />
          </div>
        </div>

         

        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : customerALLOrdersData?.length > 0 ? (
          <div
            className="scroll-bar mb-2"
            style={{
              height:
                height > 700 ? "calc(100vh - 220px)" : "calc(100vh - 200px)",
              overflowY: "auto",
            }}
          >
            <div className="report-table">
              <div className="tab-view-table">{RenderTabView()}</div>
            </div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-semi-bold">
              {selectedStoreId
                ? "No Order Found"
                : "Select a store to view orders"}
            </p>
          </div>
        )}
      </div>
      <SchedularModal
        setSchedularModalVisible={setSchedularModalVisible}
        schedularModalVisible={schedularModalVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModal}
        // typeOfOrder={orderFilterData.recordType}
      />

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default InactiveCustomer;
